import { Locale } from "@/store/translations/types";

export const LOCALES: { ENGLISH: Locale; FRENCH: Locale; ARABIC: Locale; SPANISH: Locale } = {
  ENGLISH: "en-US",
  FRENCH: "fr-FR",
  SPANISH: "es-ES",
  ARABIC: "ar",
};
